module.exports = __webpack_public_path__ + "static/media/1SD.1227adae.mp4";